import React, { forwardRef, useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";
import bgButton from "../../../../assets/images/Mini-Game/bg-button.png";
import bgButtonNewYear from "../../../../assets/images/Mini-Game/new-year-2025/action-btn-bg.png";
import iconLeft from "../../../../assets/images/Mini-Game/arrow-left.svg";
import iconI from "../../../../assets/images/Mini-Game/icon-history.svg";
import iconHistory from "../../../../assets/images/Mini-Game/icon-info.svg";
import _ from "lodash";
import iconBid from "../../../../assets/images/Mini-Game/attempt-coin.svg";
import iconTotalBid from "../../../../assets/images/Mini-Game/Coin (1).png";
import iconButtonDetail from "../../../../assets/images/Mini-Game/icon-button-detail.svg";
import iconBackThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/back-icon.png";
import iconRuleThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/rule-icon.png";
import iconHistoryThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/history-icon.png";
import iconBackNewYear from "../../../../assets/images/Mini-Game/new-year-2025/back.png";
import iconRuleNewYear from "../../../../assets/images/Mini-Game/new-year-2025/info.png";
import iconHistoryNewYear from "../../../../assets/images/Mini-Game/new-year-2025/history.png";
import eventBidBgNewYear from "../../../../assets/images/Mini-Game/new-year-2025/num-container.png";
import iconBidNewYear from "../../../../assets/images/Mini-Game/new-year-2025/bid.png";
import iconCoinNewYear from "../../../../assets/images/Mini-Game/new-year-2025/coin.png";
import {
  useNewYear2025Theme,
  useThadingyutTheme,
  // IS_EVENT_THADINGYUT_2025_THEME,
  POPUP_VARIANT_EVENT_THINGYAN_2025 as VARIANT,
} from "../../../../helper/const";
import {
  curStateAccount,
  curStateEventThingyan2025,
  curStateMiniGame,
} from "../../../../Redux/selector";
import { useDispatch, useSelector } from "react-redux";
import PopupRule from "./PopupFooter/PopupRule";
import PopupActivityHis from "./PopupFooter/PopupActivityHis";
import { getDataSpinUserMiniGame } from "../../../../Redux/futures/mini-game/action";
import muteNewYearIcon from "../../../../assets/images/Mini-Game/new-year-2025/sound-off.png";
import unmuteNewYearIcon from "../../../../assets/images/Mini-Game/new-year-2025/sound-on.png";
import { useNewYearAudioContext } from "../../../../contexts/NewYearAudioProvider";
import { useLoginModal } from "../../../../contexts/LoginModalContext";

function HeaderAction() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isShowPopupIntro, setIsShowPopupIntro] = useState(false);
  const [isShowPopupHistory, setIsShowPopupHistory] = useState(false);
  const selectorAccount = useSelector(curStateAccount);
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  const dataSpinApiRedux = useSelector(curStateMiniGame).dataSpinUserMini;
  const dataSpinSet = useSelector(curStateEventThingyan2025)?.dataSpinLeft;
  const { isPlaying: isSoundPlaying, toggleAudio } = useNewYearAudioContext();
  const { openLogin } = useLoginModal();
  useEffect(() => {
    if (selectorAccount.userInfo) {
      dispatch(getDataSpinUserMiniGame());
    }
  }, [selectorAccount.userInfo]);

  const dataSpin = !_.isEmpty(dataSpinSet)
    ? dataSpinSet
    : dataSpinApiRedux || {};

  const data = [
    { id: 1, icon: iconLeft },
    { id: 2, icon: iconI },
    { id: VARIANT.rule, icon: iconHistory },
  ];

  const dataButtonThadingyut = [
    { id: 1, icon: iconBackThadingyut },
    { id: 2, icon: iconRuleThadingyut },
    { id: VARIANT.rule, icon: iconHistoryThadingyut },
  ];

  const dataButtonNewYear = [
    {
      id: 1,
      icon: iconBackNewYear,
    },
    {
      id: 2,
      icon: iconRuleNewYear,
    },
    {
      id: VARIANT.rule,
      icon: iconHistoryNewYear,
    },
    {
      id: 4,
      icon: isSoundPlaying ? unmuteNewYearIcon : muteNewYearIcon,
    },
  ];

  const handleAction = (id) => {
    switch (id) {
      case 1:
        return navigate(-1);
      case 2:
        return setIsShowPopupIntro(true);
      case 4:
        return toggleAudio();
      case VARIANT.rule:
        return openLogin(() => setIsShowPopupHistory(true));
      default:
        return setIsShowPopupHistory(true);
    }
  };

  const renderActionButtons = () => {
    if (IS_EVENT_THADINGYUT_2025_THEME) {
      return dataButtonThadingyut.map((item) => {
        return (
          <div
            key={item.id}
            className='container-bg-action scale-hover-item'
            onClick={() => handleAction(item.id)}
          >
            {/* <img src={bgButton} alt='' className='bg-btn-header-mini' /> */}
            <img src={item.icon} alt='' className='bg-action-thingyan' />
          </div>
        );
      });
    } else if (IS_EVENT_NEW_YEAR_2025_THEME) {
      return dataButtonNewYear.map((item) => {
        return (
          <div
            key={item.id}
            className='container-bg-action scale-hover-item'
            onClick={() => handleAction(item.id)}
          >
            <img src={bgButtonNewYear} alt='' className='bg-btn-header-mini' />
            <img src={item.icon} alt='' className='bg-action-thingyan' />
          </div>
        );
      });
    } else {
      return data.map((item) => {
        return (
          <div
            key={item.id}
            className='container-bg-action scale-hover-item'
            onClick={() => handleAction(item.id)}
          >
            <img src={bgButton} alt='' className='bg-btn-header-mini' />
            <img src={item.icon} alt='' className='bg-action-thingyan' />
          </div>
        );
      });
    }
  };

  return (
    <>
      {isShowPopupIntro ? (
        <PopupRule
          isShowPopupIntro={isShowPopupIntro}
          setIsShowPopupIntro={setIsShowPopupIntro}
        />
      ) : null}

      {isShowPopupHistory ? (
        <PopupActivityHis
          isShowPopupHistory={isShowPopupHistory}
          setIsShowPopupHistory={setIsShowPopupHistory}
        />
      ) : null}

      <Container
        Bg={iconButtonDetail}
        className={
          IS_EVENT_THADINGYUT_2025_THEME
            ? "thadingyut-theme"
            : IS_EVENT_NEW_YEAR_2025_THEME
              ? "new-year-25-theme"
              : ""
        }
      >
        <div className='action-event'>{renderActionButtons()}</div>
        <div className='detail-event'>
          <div
            className={`event-bid ${dataSpin.spin_left + dataSpin.spin_left_free > 10 &&
                dataSpin.spin_left + dataSpin.spin_left_free < 99
                ? "event-bid-small"
                : dataSpin.spin_left + dataSpin.spin_left_free > 99
                  ? "event-bid-big"
                  : ""
              }`}
          >
            {IS_EVENT_NEW_YEAR_2025_THEME ? (
              <img
                srcSet={`${iconBidNewYear} 2x`}
                alt=''
                className='icon-bid-event icon-bid'
              />
            ) : (
              <img src={iconBid} alt='' className='icon-bid-event' />
            )}
            <div className='number-total'>
              {dataSpin.spin_left + dataSpin.spin_left_free || 0}
            </div>
          </div>
          <div
            className={`event-bid ${dataSpin.spin_left_super > 10 &&
                dataSpin.spin_left_super < 99
                ? "event-bid-small"
                : dataSpin.spin_left_super > 99
                  ? "event-bid-big"
                  : ""
              }`}
          >
            {IS_EVENT_NEW_YEAR_2025_THEME ? (
              <img
                srcSet={`${iconCoinNewYear} 2x`}
                alt=''
                className='icon-bid-event'
              />
            ) : (
              <img src={iconTotalBid} alt='' className='icon-bid-event' />
            )}
            <div className='number-total'>{dataSpin.spin_left_super || 0}</div>
          </div>
        </div>
      </Container>
    </>
  );
}

export default HeaderAction;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 12px 18px;
  margin-top: 0;
  padding-top: 24px;
  margin-bottom: 0;
  position: relative;
  z-index: 2;

  .event-bid {
    height: 52px;
    background-image: url(${(props) => props.Bg});
    background-size: contain; /* Đảm bảo ảnh không bị cắt */
    background-position: center;
    background-repeat: no-repeat;
    width: 95px;
    display: flex;
    gap: 10px;
    align-items: center;

    img {
      margin-left: -10px;
    }
  }

  &.thadingyut-theme {
    .event-bid {
      background: #542508 !important;
      background-clip: padding-box !important;
      border-radius: 28px !important;
      position: relative;
      border: 2px solid transparent;
      max-height: 42px;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
        background: linear-gradient(180deg, #c5a263 0%, #6a3d19 100%);
        margin: -2px;
        border-radius: inherit;
      }
    }
  }

  &.new-year-25-theme {
    .container-bg-action {
      /* &:first-child {
        width: 58px;
        height: 58px;
        position: relative;
        top: -5px;
      } */

      .bg-action-thingyan {
        width: unset !important;
        height: unset !important;
      }
    }

    .event-bid {
      background-image: url(${eventBidBgNewYear});
      width: 121px;
      gap: 24px;

      &.event-bid-small {
        gap: 18px;
      }

      &.event-bid-big {
        gap: 14px;
      }

      @media (max-width: 576px) {
        width: 85px;
        gap: 16px;
      }
    }

    .icon-bid-event {
      /* &.icon-bid {
        width: 54px;
        position: relative;
        top: -6px;
      } */
    }

    .action-event {
      .bg-action-thingyan-new-year {
        position: absolute;
        top: 50%;
        left: 50%;
        /* width: 30px;
      height: 30px; */
        transform: translate(-50%, -50%);
      }

      .bg-action-thingyan {
      }
    }
  }

  .event-bid-small {
    width: 104px;
  }

  .event-bid-big {
    width: 115px;
  }

  .number-total {
    color: white;
    font-size: 24px;
    font-weight: 700;
  }

  .detail-event {
    display: flex;
    gap: 20px;
  }

  .action-event {
    display: flex;
    gap: 8px;
    justify-content: left;

    .container-bg-action {
      position: relative;
      width: 52px;
      height: 52px;
      cursor: pointer;
    }

    .bg-action-thingyan {
      position: absolute;
      top: 50%;
      left: 50%;
      /* width: 30px;
      height: 30px; */
      transform: translate(-50%, -50%);
    }
  }

  @media (max-width: 768px) {
    .bg-btn-header-mini {
    }

    .action-event .container-bg-action {
      height: 45px;
      width: 45px;
    }

    .action-event .container-bg-action:first-child .bg-action-thingyan {
      // not apply to new year back icon
      width: 19px;
    }

    .action-event .container-bg-action:nth-child(2) .bg-action-thingyan {
      // not apply to new year rule icon
      width: 11px;
    }

    .action-event .container-bg-action:last-child .bg-action-thingyan {
      width: 25px;
    }

    /* .icon-bid-event{
      width: 45px;
    } */

    .icon-bid-event {
      margin-bottom: 0 !important;
    }
  }

  @media (max-width: 576px) {
    margin: 8px;
    margin-bottom: 0;

    .number-total {
      font-size: 18px;
    }

    .event-bid {
      height: 34px;
      width: 87px;

      .icon-bid-event {
        height: 34px;
        margin-left: -10px;
      }
    }

    .detail-event {
      gap: 12px;
    }

    .action-event {
      .container-bg-action {
        width: 34px;
        height: 34px;
        /* height: 48px; */
      }

      .bg-action-thingyan {
        width: 20px;
        height: 20px;
      }
    }
  }
`;
